import { c as _c } from "react/compiler-runtime";
import { EntitiesToolbar } from "@components/common/toolbar/entities-toolbar";
import { DEFAULT_TEAMS_SORT_BY } from "@components/teams/teams-constants";
import { TeamsSort } from "@components/teams/teams-sort";
import { useTeamsFilters } from "@components/teams/teams-filters/use-teams-filters";
import { isTeamsSortBy } from "@custom-types/type-guards";
import { useSubjectsSortByQuery } from "@hooks/use-subjects-sort-by-query";
import { TeamsDetails } from "@pages/members/teams/teams-details";
import { shouldShowTeamsPremiumPage, TeamsPremiumFeaturePage } from "@pages/members/teams/teams-premium-feature-page";
import { useTeamsPageBulkActions } from "@pages/members/teams/use-teams-page-bulk-actions";
import { TeamsTableWrapper } from "@pages/members/teams/teams-table-wrapper";
import { CreateTeam } from "@pages/members/teams/create-team";
import { canUseTeamsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { allTeamsSelector, fetchingTeamsFlagsSelector, teamsSelector } from "@store/teams/teams-selector";
import { fetchTeams } from "@store/teams/teams-slice-thunk";
import { getExportComponent } from "@utils/member-utils";
import { sortTeams } from "@utils/team-utils";
import { useEffect, useMemo } from "react";

/**
 * The component that will render the kpi details and the table for the teams
 */
export function Teams(t0) {
  const $ = _c(41);
  const {
    companyId
  } = t0;
  const teams = useAppSelector(teamsSelector);
  const allTeams = useAppSelector(allTeamsSelector);
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const dispatch = useAppDispatch();
  const canUseTeams = useAppSelector(canUseTeamsSelector);
  const isLoading = status === "pending" || status === "uninitialized";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultSort: DEFAULT_TEAMS_SORT_BY,
      isValidSort: isTeamsSortBy
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    sortBy,
    setSortBy
  } = useSubjectsSortByQuery(t1);
  const {
    isAnyFilterApplied,
    isLoadingFilters,
    filterTeams,
    filterChips
  } = useTeamsFilters();
  let t2;
  if ($[1] !== filterTeams || $[2] !== sortBy || $[3] !== teams) {
    t2 = sortTeams(filterTeams(teams), sortBy);
    $[1] = filterTeams;
    $[2] = sortBy;
    $[3] = teams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const sortedTeams = t2;
  let t3;
  let t4;
  if ($[5] !== dispatch) {
    t3 = () => {
      const searchTeams = async function searchTeams() {
        await dispatch(fetchTeams({
          searchText: ""
        }));
      };
      searchTeams();
    };
    t4 = [dispatch];
    $[5] = dispatch;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== companyId || $[9] !== teams) {
    t5 = {
      companyId,
      teams
    };
    $[8] = companyId;
    $[9] = teams;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const buttonComponents = useTeamsPageBulkActions(t5);
  const shouldRenderActions = sortedTeams.length > 0;
  if (shouldShowTeamsPremiumPage({
    canUseTeams,
    teams: allTeams,
    status
  })) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <TeamsPremiumFeaturePage />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TeamsDetails />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = sortedTeams.length;
  const t8 = isLoading || isLoadingFilters;
  const t9 = allTeams.length > 0 ? filterChips : undefined;
  let t10;
  if ($[13] !== shouldRenderActions) {
    t10 = shouldRenderActions && <CreateTeam />;
    $[13] = shouldRenderActions;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== setSortBy || $[16] !== shouldRenderActions || $[17] !== sortBy) {
    t11 = shouldRenderActions && <TeamsSort key="teams-sort" sortBy={sortBy} setSortBy={setSortBy} />;
    $[15] = setSortBy;
    $[16] = shouldRenderActions;
    $[17] = sortBy;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== buttonComponents.export || $[20] !== teams.length) {
    t12 = getExportComponent(teams.length, buttonComponents.export);
    $[19] = buttonComponents.export;
    $[20] = teams.length;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== isAnyFilterApplied || $[23] !== sortedTeams.length || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t8 || $[28] !== t9) {
    t13 = <EntitiesToolbar toolbarEntityName="Team" numberOfRows={t7} isLoading={t8} filterChips={t9} isAnyFilterApplied={isAnyFilterApplied} mobileAction={t10} sortActions={t11} exportComponent={t12} />;
    $[22] = isAnyFilterApplied;
    $[23] = sortedTeams.length;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t8;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== buttonComponents || $[31] !== companyId || $[32] !== isAnyFilterApplied || $[33] !== isLoadingFilters || $[34] !== setSortBy || $[35] !== sortBy || $[36] !== sortedTeams) {
    t14 = <TeamsTableWrapper companyId={companyId} sortedTeams={sortedTeams} isFiltering={isAnyFilterApplied} isLoadingFilters={isLoadingFilters} buttonComponents={buttonComponents} sortBy={sortBy} setSortBy={setSortBy} />;
    $[30] = buttonComponents;
    $[31] = companyId;
    $[32] = isAnyFilterApplied;
    $[33] = isLoadingFilters;
    $[34] = setSortBy;
    $[35] = sortBy;
    $[36] = sortedTeams;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t13 || $[39] !== t14) {
    t15 = <>{t6}{t13}{t14}</>;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}